var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-tree',{ref:"structTree",staticClass:"struct-tree",attrs:{"data":_vm.data,"node-key":"id","props":{
    label: 'name',
    children: 'children',
  },"empty-text":"","default-expand-all":true,"highlight-current":true},on:{"current-change":_vm.OnChange},scopedSlots:_vm._u([{key:"default",fn:function(ref){
  var node = ref.node;
  var data = ref.data;
return _c('div',{class:['custom-tree-node', data.level > 0 ? 'custom-tree-children' : 'custom-tree-root'],style:('text-indent:' + (20 * data.level) + 'px')},[_vm._v("\n    "+_vm._s(node.label)+"\n    \n  ")])}}])})}
var staticRenderFns = []

export { render, staticRenderFns }